<template>
  <div class="app-shell" :style="themeStyle">
    <site-header />
    <site-announcement />
    <div v-if="$store.state.userError" class="account-load-error" role="alert"><span>{{ $store.state.userError }}</span><button :disabled="retryingUser" @click="retryUser">{{ retryingUser ? '正在重试...' : '重试' }}</button></div>
    <main class="page-wrap"><router-view /></main>
    <footer class="site-footer">
      <div class="footer-inner">
        <strong>{{ siteName }}</strong>
        <span>内容播放与会员服务</span>
        <a v-if="contactUrl" class="footer-contact" :href="contactUrl" target="_blank" rel="noopener noreferrer">联系我们</a>
        <span v-if="copyrightText" class="footer-copyright">{{ copyrightText }}</span>
      </div>
    </footer>
  </div>
</template>

<script>
import SiteHeader from './components/SiteHeader'
import SiteAnnouncement from './components/SiteAnnouncement'
import { AUTH_INVALID_EVENT } from '@/utils/auth'
import { promotionHref } from '@/utils/promotionLink'

export default {
  name: 'App',
  components: { SiteHeader, SiteAnnouncement },
  data () { return { retryingUser: false } },
  computed: {
    siteName () { return this.$store.getters.siteName },
    contactUrl () { return promotionHref(this.$store.state.config.contactUrl) },
    copyrightText () { return String(this.$store.state.config.copyrightText || '').trim() },
    themeStyle () {
      return { '--brand': this.$store.state.config.themeColor || '#f04438' }
    }
  },
  created () {
    window.addEventListener(AUTH_INVALID_EVENT, this.clearExpiredUser)
    this.$store.dispatch('loadHome')
    this.$store.dispatch('loadUser')
  },
  beforeDestroy () {
    window.removeEventListener(AUTH_INVALID_EVENT, this.clearExpiredUser)
  },
  methods: {
    retryUser () {
      if (this.retryingUser) return
      this.retryingUser = true
      this.$store.dispatch('loadUser').finally(() => { this.retryingUser = false })
    },
    clearExpiredUser () {
      this.$store.commit('SET_USER', null)
      this.$store.commit('SET_USER_ERROR', '')
    }
  }
}
</script>

<style scoped>
.footer-copyright{min-width:0;max-width:100%;overflow-wrap:anywhere;line-height:1.6}
.footer-inner{flex-wrap:wrap;align-items:center}.footer-contact{color:#d1d3da;white-space:nowrap;padding:6px 0}.footer-contact:hover{color:var(--brand);text-decoration:underline}.footer-contact:focus-visible{outline:2px solid var(--brand);outline-offset:4px}
.account-load-error{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;gap:12px;padding:12px 16px;font-size:13px;background:#352725;color:#f2c5bd}.account-load-error button{background:transparent;border:0;color:inherit;text-decoration:underline;cursor:pointer}.account-load-error button:disabled{opacity:.6}
</style>



// WEBPACK FOOTER //
// src/App.vue